import { INavMenuItem } from "@types";

export const findNavItemByKey = (
  navItems: INavMenuItem[],
  navKey: string
): INavMenuItem | undefined => {
  for (const item of navItems) {
    if (item.navKey === navKey) return item;
    if (item.subs) {
      const found = findNavItemByKey(item.subs, navKey);
      if (found) return found;
    }
  }
  return undefined;
};
